export const environment = {
  production: false,
  baseUrl: 'https://homologacao.vivest.com.br',
  baseUrlCdn: 'https://vivest-hmg-cdn.azureedge.net',
  baseUrlScaf: 'https://www.vivest.com.br',
  baseUrlFacil: 'https://autorizacaohomofuncesp.facilinformatica.com.br',
  chaveFornecedor: '7788f344-4e9b-4938-b11f-7f847c9d230c',
  secretPortal: '79f52b2cc565ef16f07d7f8f52df4ecdd7fa1923995f16333fc4b2055476a146',
  secretPortalScaf: '29ff1cf960bc6fe3a4bd29d22ba65dedffcc85f5a1d76d09ac825e6b0a047eba',
  secretIR: 'VIVEST-DOCUMENTOS-IR-HMG',
  oacpScaf: '197dd8ab97194c9d80515991995ebe40',
  oacpInforme: 'a277b077953c44ad9c56b9624d96272c',
  oacpSoftexpert: '9a08e7aa2d5b4fafb46073b27a515a61',
  ocpDadosCadastrais: '01a4c2237d15441ca97986c11eeaf176',
  notificationsubscriptionkey: 'e3e155f8ab744036b83f9e8dfbe72d17',
  featureId: 54
};
